
import competitions from '@sportOfferFederation/competitions/store/ui';
import { CompetitionsState } from '@sportOfferFederation/competitions/store/ui/types';
import Help, { IHelpState } from '@store/modules/ui/help/helpIndex';
import User, {
    IUserState,
    UIUserGetters,
} from '@store/modules/ui/user/userIndex';

import Inbox from './inbox/inboxIndex';
import PromotionHub, { PromotionHubState } from './promotionHub/promotionHubIndex';
import Results from './results';
import Modal, { ModalsState } from './shared/modal/modalIndex';
import MultiStepVerification from './shared/multiStepVerification/multiStepVerificationIndex';
import SportOffer, { ISportOfferState } from './sportOffer/sportOfferIndex';
import { ISportOfferGetters } from './sportOffer/sportPage/types';
import Alerts, { AlertsState } from '@modules/alerts/alertsStore';
import Popover, { PopoversState } from './shared/popover/popoverIndex';
import EventDetails, { EventDetailsState } from '@modules/eventDetailsPage/store';

export interface IUiState {
    sportOffer: ISportOfferState;
    modal: ModalsState;
    popover: PopoversState
    alerts: AlertsState;
    multiStepVerification: Record<string, unknown>;
    user: IUserState;
    help: IHelpState;
    competitions: CompetitionsState;
    promotionHub: PromotionHubState;
    eventDetails: EventDetailsState;
}
export interface UIGetters {
    user: UIUserGetters;
    sportOffer: ISportOfferGetters
}

export default {
    namespaced: true,
    modules: {
        sportOffer: SportOffer,
        modal: Modal,
        popover: Popover,
        multiStepVerification: MultiStepVerification,
        user: User,
        help: Help,
        results: Results,
        competitions,
        inbox: Inbox,
        promotionHub: PromotionHub,
        alerts: Alerts,
        eventDetails: EventDetails,
    },
};
